<template>
  <div style="font-size: 14px;">
    <span v-if="props.column.field == 'active'">
      <toggle-button
        class="toggle-btn"
        @change="switchActive($event, props)"
        :value="props.row.active == 1 ? true : false"
        color="#006eee"
        :labels="false"
        :sync="true"
      />
    </span>
    <span
      v-else-if="props.column.field == 'template_name'"
      @click="$emit('on-row-click', props)"
    >
      <span class="d-flex justify-content-start align-items-center">
        {{ props.row.template_name }}
        <status-indicator
          class="ml-2"
          :active="status(props.row.active == 1 ? true : false)"
          :pulse="status(props.row.active == 1 ? true : false)"
        ></status-indicator
      ></span>
    </span>
    <span v-else-if="props.column.field == 'application'">
      {{
        props.row.application[0].name
        /*props.row.application[0].name.length > 20
          ? props.row.application[0].name.substring(0, 20) + '...'
          : props.row.application[0].name*/
      }}
    </span>
    <span v-else-if="props.column.field == 'application_name'">
      {{
        props.formattedRow[props.column.field]
      }}
    </span>
    <span v-else-if="props.column.field == 'description'">
      <div v-html="splitStringByLength(props.row.description)" />
    </span>
    <span v-else-if="props.column.field == 'email'">
      {{
        props.row.email
      }}
    </span>
    <span v-else-if="props.column.field == 'company'">
      {{
        props.row.company.map((item) => item.name).toString().length > 20
          ? props.row.company
              .map((item) => item.name)
              .toString()
              .substring(0, 20) + '...'
          : props.row.company.map((item) => item.name).toString()
      }}
    </span>
    <span v-else-if="props.column.field == 'category'">
      {{
        props.row.category.map((item) => item.name).toString().length > 20
          ? props.row.category
              .map((item) => item.name)
              .toString()
              .substring(0, 20) + '...'
          : props.row.category.map((item) => item.name).toString()
      }}
    </span>
    <span v-else-if="props.column.field == 'group'">
      {{
        props.row.group.map((item) => item.name).toString()
        /*props.row.group.map((item) => item.name).toString().length > 20
          ? props.row.group
              .map((item) => item.name)
              .toString()
              .substring(0, 20) + '...'
          : props.row.group.map((item) => item.name).toString()*/
      }}
    </span>
    <span v-else-if="props.column.field == 'group_name'">
      {{
        props.row.group_name
      }}
    </span>
    <span v-else-if="props.column.field == 'symptom_name'">
      {{
        props.row.symptom_name
      }}
    </span>
    <span v-else-if="props.column.field == 'announcement_type'">
      {{
        props.row.announcement_type
      }}
    </span>
    <span v-else-if="props.column.field == 'type'">
      {{
        props.row.type
      }}
    </span>
    <span v-else-if="props.column.field == 'member'">
      <span>
        {{
          props.row.member.map(fullName).toString()
        }}
      </span>
    </span>
    <span
      v-else-if="props.column.field == 'created_at'"
      @click="$emit('on-row-click', props)"
    >
      <span> {{ props.row.created_at | moment('YYYY-MM-DD, HH:mm:ss') }}</span>
    </span>
    <span
      v-else-if="props.column.field == 'updated_at'"
      @click="$emit('on-row-click', props)"
    >
      <span> {{ props.row.updated_at | moment('YYYY-MM-DD, HH:mm:ss') }}</span>
    </span>
    <span v-else-if="props.column.field == 'date'">
      {{ props.row.date | moment('YYYY-MM-DD, HH:mm:ss') }}
    </span>
    <span v-else-if="props.column.field == 'date_only'">
      {{ props.row.date | moment('YYYY-MM-DD') }}
    </span>
    <span v-else-if="props.column.field == 'received_date_time'">
      {{ props.row.received_date_time | moment('YYYY-MM-DD, HH:mm:ss ') }}
    </span>
    <span v-else-if="props.column.field == 'distribute_date_time'">
      {{ props.row.distribute_date_time | moment('YYYY-MM-DD, HH:mm:ss ') }}
    </span>
    <span v-else-if="props.column.field == 'status'">
      <!-- {{ props.row.status }} -->
      <toggle-button
        :key="props.row._id"
        @change="onStatusChange(props, $event)"
        :value="props.row.status.match('Enable') ? true : false"
        :width="75"
        :height="25"
        color="#2971FF"
        :labels="{ checked: 'Enable', unchecked: 'Disable' }"
      />
    </span>
    <span v-else-if="props.column.field == 'name'">
      {{ props.row.name.replace(':', ' ') }}
    </span>
    <span
      v-else-if="props.column.field == 'note'"
      class="d-flex justify-content-center"
    >
      <i
        @click="clicked(props.row.id)"
        style="color: #358dff; background-color: #c1dcff"
        class="icon-comment rounded-circle p-2"
      ></i>
    </span>
    <span
      v-else-if="props.column.field == 'evaluation'"
      class="d-flex justify-content-center"
      @click="$emit('eval', props)"
    >
      <span>
        <i
          style="color: #2c5dff; background-color: #b3c5ff"
          class="icon-file rounded-circle p-2"
        ></i
      ></span>
    </span>
    <span
      v-else-if="props.column.field == 'action'"
      class="d-flex justify-content-center"
    >
      <b-dropdown
        variant="black"
        toggle-class="text-decoration-none p-0 "
        no-caret
      >
        <template #button-content>
          <i class="icon-more-alt rounded-circle p-2 action"></i>
        </template>
        <b-dropdown-item @click="$emit('modal', 'View', props)"
          >View</b-dropdown-item
        >

        <div v-if="$route.name !== 'Case'">
          <b-dropdown-item @click="$emit('modal', 'Edit', props)"
            >Edit</b-dropdown-item
          >

          <b-dropdown-item @click="$emit('deleteRow', props)"
            >Delete</b-dropdown-item
          >
        </div>
        <b-dropdown-item
          v-if="$route.name == 'Case'"
          @click="$emit('resend', props)"
          >Resend</b-dropdown-item
        >
      </b-dropdown>
    </span>
    <span v-else-if="props.column.field == 'sender'">
      {{ props.formattedRow[props.column.field] }}
    </span>
    <span v-else-if="props.column.field == 'subject'">
      {{ props.formattedRow[props.column.field] }}
    </span>
    <span
      v-else-if="props.column.field == 'role_beacon' && role_beacon == 'admin'"
    >
      {{ props.formattedRow[props.column.field] }}
    </span>
    <span v-else-if="props.column.field == 'role_ccp' && role_ccp == 'admin'">
      {{ props.formattedRow[props.column.field] }}
    </span>
    <span v-else @click="$emit('on-row-click', props)">
      {{
        props.formattedRow[props.column.field].length > 20
          ? props.formattedRow[props.column.field].substring(0, 20) + '...'
          : props.formattedRow[props.column.field]
      }}
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      props: Object,
    },
    data() {
      return {
        indicator: null,
        role_ccp: '',
        role_beacon: '',
      };
    },
    computed: {},
    mounted() {
      let userinfo = localStorage.getItem('userinfo');
      userinfo = JSON.parse(userinfo);
      if (userinfo.role_ccp != undefined) {
        this.role_ccp = userinfo.role_ccp;
      }
      if (userinfo.role_beacon != undefined) {
        this.role_beacon = userinfo.role_beacon;
      }
    },
    methods: {
      onStatusChange(v, e) {
        this.$emit('status', v, e.value);
      },
      fullName(item) {
        return [item.first_name, item.last_name].join(' ');
      },
      clicked(clickedId) {
        this.$emit('clicked', clickedId);
      },
      resend(v) {
        this.$emit('resend', v);
      },
      status(p) {
        return p;
      },
      view() {},
      splitStringByLength(inputString) {
        if (inputString == ""){
          return "";
        }
        const maxLength = 20;
        const regex = new RegExp(`.{1,${maxLength}}`, 'g');
        return inputString.match(regex).join('\n');
      }
      // async switchActive(e, p) {
      //   var template = {
      //     template_name: p.row.template_name,
      //     type: p.row.type,
      //     data: p.row.data,
      //     active: e.value ? 1 : 0,
      //   };
      //   var url = `${crm_host}/api/templates/${p.row._id}?organize_id=${p.row.organize_id}`;
      //   const requestOptions = {
      //     method: 'POST',
      //     headers: { 'Content-Type': 'application/json' },
      //     body: JSON.stringify(template),
      //   };

      //   const resActive = await fetch(url, requestOptions);
      //   const Active = await resActive.json();
      //   console.log(Active);
      //   // console.log(p.index);
      //   this.$emit('active', p.index);
      //   // props.row.active = p.row.active ? 1 : 0;
      // },
    },
  };
</script>

<style>
  .toggle-btn {
    z-index: 999 !important;
  }

  .action {
    transition: 200ms;
  }
  .action:hover {
    background: rgb(207, 207, 207);
  }
</style>
